import type { IconData } from '@stacksjs/iconify-core'

export const aperture: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M256.684 16.736A239.3 239.3 0 0 0 87.475 425.245a239.3 239.3 0 0 0 338.419-338.42a237.74 237.74 0 0 0-169.21-70.089m-9.9 32.242L146.033 224.237l-53.985-94.011a207.14 207.14 0 0 1 154.739-81.248Zm56.437 127.035l45.912 79.413l-46.2 80.791h-92.6l-45.859-79.859l46.189-80.345ZM72.648 160.7l100.788 175.517H65.526A207.1 207.1 0 0 1 72.648 160.7m9.791 207.515h202.2l-53.494 93.542a207.58 207.58 0 0 1-148.706-93.54Zm184.818 94.849L367.668 287.48l54.168 93.692a207.17 207.17 0 0 1-154.579 81.894ZM441.125 350.6L340.187 176.013h107.721a207.13 207.13 0 0 1-6.783 174.587M229.063 144.013l53.825-93.627a207.6 207.6 0 0 1 148.147 93.627Z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default aperture
